var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1600 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 1600,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2c0109",
    points: "1600 160 0 460 0 350 1600 50"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#580211",
    points: "1600 260 0 560 0 450 1600 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#85031a",
    points: "1600 360 0 660 0 550 1600 250"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b10422",
    points: "1600 460 0 760 0 650 1600 350"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e31837",
    points: "1600 800 0 800 0 750 1600 450"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c640a4ec89f6641093781c0f0aae59c4.svg";
export { ForwardRef as ReactComponent };